import {
  CardContent,
  Grid,
  ListItem,
  ListItemText,
  Typography,
  useEventCallback,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PmiCard } from 'shell/components/shared/card';
import PmiTitle from 'shell/components/shared/title';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import { ItemVM } from 'shell/view-models/item';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { ActWizard } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformerMenu } from 'civil-status/utils/transformer-menu';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { DataWizardAct } from 'civil-status/view-models/step-form';
import { STATES_ACT } from 'civil-status/constants/states-act';
import { AxiosResponse } from 'axios';

const SubMenuPagePost = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();

  const [dataFormazioneAtto, setDataFormazioneAtto] = useState('');

  const basePathPre = `/stato-civile/${params.valueCat}/${params.idCat}/${params.sottoMenuName}/${params.idEvento}`;
  const basePath = `${basePathPre}/${params.valuePostCat}/${params.idPostCat}`;

  const nameSection = useEventCallback(() => {
    switch (params.idPostCat?.toString()) {
      case '11':
        return 'Tipo di filiazione';
      case '12':
        return 'Tipo riconoscimento';
      case '14':
      case '23':
      case '36':
      case '45':
      case '53':
        return 'Tipo annotazione';
      case '18':
        return 'Tipo scelta cognome';
      case '13':
      case '22':
      case '43':
      case '33':
        return 'Tipo trascrizione';
      case '21':
        return 'Tipo dichiarazione';
      case '31':
        return 'Rito civile';
      case '32':
        return 'Rito religioso';
      case '34':
        return 'Tipo separazione e divorzio';
      case '35':
        return 'Tipo riconciliazione';
      case '41':
        return 'Tipo rito civile';
      case '44':
        return 'Tipo scioglimento';
      case '51':
      case '52':
        return 'Tipo evento cittadinanza';
      default:
        return '';
    }
  });

  const [requests] = useHttpFetch<HttpResponse<ActWizard>, HttpResponse<ActWizard>>(
    `${__ACT_API_URL__}/wizard/questionario`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          codStep: params.idPostCat || undefined,
          idEvento: params.idEvento ? Number.parseInt(params.idEvento, 10) : undefined,
        },
      },
      transformer: (response) => {
        setDataFormazioneAtto(response.data.payload.statoCivile.dataFormazioneAtto || '');
        return response.data as unknown as HttpResponse<ActWizard>;
      },
    }
  );

  const requestsData = (transformerMenu(
    requests as unknown as AxiosResponse<HttpResponse<ActWizard>>
  ) || []) as Array<ItemVM>;

  const saveData = useHttpClient(`${__ACT_API_URL__}/wizard/save`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const onClickCard = useEventCallback((item: ItemVM) => {
    const elementData = (
      requests as unknown as AxiosResponse<HttpResponse<ActWizard>>
    ).data.payload.percorsoQuestionarioVOList?.find(
      (itemCurrent) => itemCurrent.key?.codStepSuccessivo === item.id
    );

    const { evento } = (requests as unknown as AxiosResponse<HttpResponse<ActWizard>>).data.payload;

    const data: DataWizardAct = {
      questionarioEvento: [
        {
          key: {
            idEvento: params.idEvento ? Number.parseInt(params.idEvento, 10) : undefined,
            numProgressivoStep: 1,
          },
          cdStepSuccessivo: params.idCat || undefined,
          codStep: ' ',
          descBreveDomanda: 'Evento',
          descBreveRisposta: params.valueCat || undefined,
        },
        {
          key: {
            idEvento: params.idEvento ? Number.parseInt(params.idEvento, 10) : undefined,
            numProgressivoStep: 2,
          },
          cdStepSuccessivo: params.idPostCat,
          codStep: params.idCat,
          descBreveDomanda: 'Tipo atto',
          descBreveRisposta: params.valuePostCat || undefined,
        },
        {
          key: {
            idEvento: params.idEvento ? Number.parseInt(params.idEvento, 10) : undefined,
            numProgressivoStep: 3,
          },
          cdStepSuccessivo: item.id?.toString() || undefined,
          codStep: params.idPostCat,
          descBreveDomanda: nameSection(),
          descBreveRisposta: item.value || undefined,
        },
      ],
      statoCivile: {
        dataFormazioneAtto,
        parteAtto: elementData?.cdParte || undefined,
        serie1Atto: elementData?.cdSerie1 || undefined,
        serie2Atto: elementData?.cdSerie2 || undefined,
        tipoAtto: params.idPostCat,
        // tipoEvento: params.valueCat || undefined,
        tipoEvento: params.idCat || undefined,
        tipoContenuto: evento.tipoContenuto || undefined,
        codiceStatoEvento: STATES_ACT.ID_STATE_BOZZA,
        key: {
          idEvento: params.idEvento ? Number.parseInt(params.idEvento, 10) : undefined,
        },
      },
      evento: {
        dataFormazioneAtto,
        tipoContenuto: evento.tipoContenuto || undefined,
        // tipoEvento: params.valueCat || undefined,
        tipoEvento: params.idCat || undefined,
        codiceStatoEvento: STATES_ACT.ID_STATE_BOZZA,
        key: {
          idEvento: params.idEvento ? Number.parseInt(params.idEvento, 10) : undefined,
        },
      },
    };

    (
      saveData({
        data,
      }) as unknown as ResponsePromise<void>
    ).then(() => {
      navigate(`${basePath}/${item.value}/${item.id}`);
    });
  });

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonCivilStatusCrumbs,
          {
            name: 'Tipo atto',
            path: basePathPre,
          },
          {
            name: nameSection(),
            path: basePath,
          },
        ]}
      />
      <PmiTitle title={nameSection()} paddingBottom={1} />
      <div className="pmi-mb-4">
        <Typography component="div" fontSize=".9rem" color="primary">
          {"Seleziona l'area su cui operare"}
        </Typography>
      </div>
      <Grid container spacing={2}>
        {requestsData.map((item) => (
          <Grid item xs={12} md={4} key={`${item.value}-${item.id}`}>
            <span onClick={() => onClickCard(item)} style={{ cursor: 'pointer' }}>
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary={item.value} />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </span>
          </Grid>
        ))}
      </Grid>
    </Fragment>
  );
};

SubMenuPagePost.displayName = 'Sub Menu Page Post';

export default SubMenuPagePost;
